export default __webpack_public_path__ + "static/media/5.63fa9e5b.jpg";